import { useEffect } from "react";
import SHOP from "@/config/shop";

export function useSEO(title, description) {
  useEffect(() => {
    const suffix = ` | ${SHOP.domain}`;
    document.title = title ? `${title}${suffix}` : `${SHOP.domain} | ${SHOP.seoDefault}`;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && description) metaDesc.setAttribute('content', description);
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title || SHOP.domain);
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc && description) ogDesc.setAttribute('content', description);
  }, [title, description]);
}
